var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import { Savable } from '@/common/mixins/Savable';
import { EnumHelpers } from '@/common/mixins/EnumHelpers';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import ListRow from '@/common/components/ListRow.vue';
import HeaderControl from '@/common/components/HeaderControl.vue';
import MeasuredTargetControl from '@/template/components/summaryReport/controls/MeasuredTargetControl.vue';
import PlainTextControl from "@/common/components/PlainTextControl.vue";
import { Results } from '@/common/types/Results';
import { Meter } from '@/common/types/Meter';
var ResultsView = /** @class */ (function (_super) {
    __extends(ResultsView, _super);
    function ResultsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.meterKey = "";
        return _this;
    }
    ResultsView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
        if (this.meters.length == 0) {
            this.create();
        }
    };
    Object.defineProperty(ResultsView.prototype, "meters", {
        get: function () {
            return this.results.meters;
        },
        set: function (value) {
            this.results.meters = value;
        },
        enumerable: false,
        configurable: true
    });
    ResultsView.prototype.create = function () {
        var _this = this;
        var meter = new Meter();
        this.meters.push(meter);
        this.forceSave();
        this.$nextTick().then(function () {
            var targetClass = "meter-" + (_this.meters.length - 1);
            _this.focusOnComponentClass(targetClass);
        });
    };
    /**
     * Delete a operation from the list of operations.
     * @param key Key of the operation to remove
     */
    ResultsView.prototype.deleteMeter = function (meter) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                if (confirm(this.$i18n.t("SummaryReport.Confirm.Meter").toString())) {
                    index = this.meters.indexOf(meter);
                    this.meters.splice(index, 1);
                    this.forceSave();
                    this.meterKey = Date();
                }
                return [2 /*return*/];
            });
        });
    };
    ResultsView.prototype.getMeasuredTargetTitle = function (index) {
        return this.$t("SummaryReport.Results.MeasuredTargetWithIndex", [(index + 1).toString()]);
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof Results !== "undefined" && Results) === "function" ? _a : Object)
    ], ResultsView.prototype, "results", void 0);
    ResultsView = __decorate([
        Component({
            name: "ResultsView",
            components: {
                TextAreaRow: TextAreaRow,
                ListRow: ListRow,
                HeaderControl: HeaderControl,
                MeasuredTargetControl: MeasuredTargetControl,
                PlainTextControl: PlainTextControl
            }
        })
    ], ResultsView);
    return ResultsView;
}(Mixins(Focusable, Savable, EnumHelpers)));
export default ResultsView;
